import { AfterViewInit, Component, Input, OnDestroy, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements AfterViewInit, OnDestroy {
  @Input() message: string;
  @Input() aboveOverlays = false;
  @ViewChild('loaderContent', { static: true }) loaderContent!: TemplateRef<unknown>;
  private overlayRef?: OverlayRef;

  constructor(private overlay: Overlay, private viewContainerRef: ViewContainerRef) {}

  ngAfterViewInit(): void {
    if (!this.aboveOverlays || this.inline) return;

    this.overlayRef = this.overlay.create({
      positionStrategy: this.overlay.position().global().top('0').left('0'),
      width: '100%',
      height: '100%',
    });
    // Both overlays live under the CDK container; raise the entire loader layer.
    this.overlayRef.hostElement.style.zIndex = '100000';
    this.overlayRef.overlayElement.style.zIndex = '100000';
    this.overlayRef.attach(new TemplatePortal(this.loaderContent, this.viewContainerRef));
  }

  ngOnDestroy(): void {
    this.overlayRef?.dispose();
  }

  /**
   * Render in the flow instead of as a full-screen overlay. For loading that
   * adds to what is already on screen — a table paging in its next rows —
   * where dimming the whole page on every scroll would be wrong.
   */
  @Input() inline = false;
}
